import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { useContentObjectType } from 'content-management-data-lib';
import useFetchScopeChangeInfo from '../hooks/useFetchScopeChangeInfo';
import { getShouldShowScopeChangeAlert } from '../utils/downgradeAlerts';
import { jsx as _jsx } from "react/jsx-runtime";
const ScopeDowngradeAlert = ({
  alertSpaceStyleProps,
  scopeName,
  isPageUsingScope,
  alertType,
  userScopes,
  viewMode,
  filtersForFetchingCount
}) => {
  const {
    contentObjectType
  } = useContentObjectType();
  const {
    scopeChangeInfo
  } = useFetchScopeChangeInfo({
    scopeName,
    contentObjectType,
    skip: userScopes.includes(scopeName),
    viewMode,
    filters: filtersForFetchingCount
  });
  const alertRequiresCount = !!filtersForFetchingCount && viewMode === 'LIST';
  if (scopeChangeInfo && getShouldShowScopeChangeAlert({
    scopeChangeInfo,
    isPageUsingScope,
    viewMode,
    alertRequiresCount
  })) {
    const {
      purgedTime,
      count
    } = scopeChangeInfo;
    const options = {
      date: I18n.moment.portalTz(purgedTime).format('l')
    };
    if (alertRequiresCount) {
      options.count = count;
    }
    return /*#__PURE__*/_jsx(Alert, Object.assign({
      "data-test-id": `downgrade-alert-${alertType}`,
      titleText: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `page-lib.downgradeAlerts.${viewMode}.${alertType}.title`,
        options: options
      }),
      type: "danger"
    }, alertSpaceStyleProps, {
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `page-lib.downgradeAlerts.${viewMode}.${alertType}.body`,
        options: options
      })
    }));
  }
  return null;
};
export default ScopeDowngradeAlert;